module.exports = __webpack_public_path__ + "img/quotes-maroon.15964b9.svg";